import React from 'react'
import "./AverageRateComparasionRow.css"

const AverageRateComparasionRow = (props) => {

    const { label, first, second, third } = props;

    return (
        <div className='d-flex avg-rate-row'>
            <div className='my-auto label-box' style={{ flex: "0.25" }}>
                <p className='my-auto t-secondary-color'>Taux Moyen</p>
                <p className='my-auto t-secondary-color t-bold'>{label}</p>
            </div>
            <div className='my-auto first-box' style={{ flex: "0.25" }}>
                <p className='t-primary-color box-text'>{first == "NaN"? "00" : first}{" %"}</p>
            </div>
            <div className='my-auto second-box' style={{ flex: "0.25" }}>
                <p className='t-primary-color box-text'>{second == "NaN"? "00" : second}{" %"}</p>
            </div>
            <div className='my-auto third-box' style={{ flex: "0.25" }}>
                <p className='t-primary-color box-text'>{third == "NaN"? "00" : third}{" %"}</p>
            </div>
        </div>
    )
}

export default AverageRateComparasionRow